import { Box, Paper, Skeleton, Typography } from '@mui/material'
import { ArrowForwardIos, MenuBook } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { WrapService } from '../../services/wrap.service'
import { useError } from '../../context/error'

interface WrapLite {
  id?: string
  date?: string
  createdAt?: string
}

export default function LastWrap() {
  const { setError } = useError()
  const wrapService = new WrapService(setError)
  const [wrap, setWrap] = useState<WrapLite | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    wrapService.searchWraps(1, undefined, 1).then(res => {
      if (cancelled) return
      const first = res?.docs?.[0] ?? res?.wraps?.docs?.[0] ?? res?.wraps?.[0] ?? null
      setWrap(first)
      setLoading(false)
    })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dateLabel = (() => {
    const raw = wrap?.date ?? wrap?.createdAt
    if (!raw) return ''
    const d = new Date(raw)
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })
  })()

  return (
    <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
      <Box display='flex' alignItems='center' gap={1} mb={1}>
        <MenuBook fontSize='small' color='action' />
        <Typography variant='subtitle2' fontWeight={700} color='text.secondary' sx={{ letterSpacing: 1 }}>
          LAST WRAP
        </Typography>
      </Box>

      {loading ? (
        <>
          <Skeleton variant='text' width='80%' />
          <Skeleton variant='text' width='30%' />
        </>
      ) : !wrap ? (
        <Typography variant='body2' color='text.secondary'>No wrap available.</Typography>
      ) : (
        <RouterLink
          to={wrap.id ? `/daily-wrap/view?id=${wrap.id}` : '/daily-wrap'}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Typography variant='subtitle1' fontWeight={600}>
            {dateLabel || 'Daily Wrap'}
          </Typography>
          <Box display='flex' alignItems='center' gap={0.5} mt={0.5}>
            <Box flex={1} />
            <Typography
              variant='caption'
              color='primary'
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
            >
              Read wrap <ArrowForwardIos sx={{ fontSize: 10 }} />
            </Typography>
          </Box>
        </RouterLink>
      )}
    </Paper>
  )
}
